module.exports = __webpack_public_path__ + "img/1499149805.6957edae.jpg";